import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getCustomer } from "@State/index";
import CustomerDetails from "../CustomerDetails";
import CustomerSettingsModal from "../../CustomerSettingsModal";
import { getHeaderLeftComponent } from "@View/components/headers/HeaderMain";
import { changeAppLanguage } from "@Localization/utils";
import WarningIcon from "@mui/icons-material/Warning";
import SettingsIcon from "@mui/icons-material/Settings";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { getCustomerGroups } from "@State/actions/actionsGet/actionGetCustomer";
import { Button } from "@mui/material";
import { useBackButton } from "@View/hooks/useBackButton";
import { canEditCustomer } from "@Security/stateHelpers";

const CustomerHeader = ({ customerId }) => {
  const customer = useSelector((state) => state.customer.customer);
  const dispatch = useDispatch();
  const [openDetails, setOpenDetails] = React.useState(false);
  const [openSettings, setOpenSettings] = React.useState(false);
  const [settingsSection, setSettingsSection] = React.useState("general");

  const handleOpenDetails = () => {
    setOpenDetails(true);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const handleOpenActivation = () => {
    setSettingsSection("subscription");
    setOpenSettings(true);
  };

  const handleOpenSettings = () => {
    setSettingsSection("general");
    setOpenSettings(true);
  };

  const handleCloseSettings = () => {
    setOpenSettings(false);
  };

  /** @todo move outside */
  const LeftComponent = () => {
    const { t } = useTranslation();
    const showWarning = !customer.isActiveSubscription;
    const backButtonVisible = useBackButton();

    return (
      <div
        style={{
          marginLeft: backButtonVisible ? "24px" : "",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            onClick={() => handleOpenDetails()}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                marginRight: "15px",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "19px",
                color: "#1A1E24",
              }}
            >
              {customer.name}
            </div>
            <InfoOutlinedIcon
              titleAccess={t("Customer Details")}
              sx={{
                fontSize: 18,
                color: "#54606F",
                "&:hover": { color: "#1A1E24" },
              }}
            />
          </div>
          {canEditCustomer() && (
            <SettingsIcon
              onClick={handleOpenSettings}
              titleAccess={t("Settings")}
              sx={{
                marginLeft: "10px",
                fontSize: 18,
                color: "#54606F",
                cursor: "pointer",
                "&:hover": { color: "#1A1E24" },
              }}
            />
          )}
        </div>
        <div
          style={{
            fontSize: "12px",
            color: showWarning ? "orange" : "#54606F",
            position: "relative",
            top: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: "4px",
          }}
        >
          {" "}
          {showWarning && (
            <WarningIcon sx={{ color: "orange", fontSize: 20 }} />
          )}{" "}
          <div>
            {customer.isActiveSubscription
              ? `${t("subscription.activeUntil")} ${
                  customer.subscriptionUntil
                    ? new Date(customer.subscriptionUntil).toLocaleDateString()
                    : t("subscription.notSpecified")
                }. ${t("subscription.requestsLeft")}: ${customer.requestsLeft}`
              : t("subscription.noActiveSubscription")}
          </div>
          {!customer.isActiveSubscription && (
            <Button
              variant="contained"
              size="small"
              onClick={handleOpenActivation}
              style={{
                marginLeft: "8px",
                fontSize: "10px",
                padding: "2px 8px",
                minWidth: "auto",
                height: "18px",
                backgroundColor: "#54606F",
                color: "#F3F5F7",
                textTransform: "none",
                fontWeight: 600,
                borderRadius: "4px",
                boxShadow: "none",
              }}
              sx={{
                "&:hover": {
                  backgroundColor: "#394554",
                  color: "#F3F5F7",
                  boxShadow: "none",
                },
              }}
            >
              {t("buttons.Activate")}
            </Button>
          )}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (customerId) {
      dispatch(getCustomer(customerId));
      dispatch(getCustomerGroups(customerId));
    }
  }, [customerId]);

  /** @todo think about different way for displaying this component, avoid store components in state */
  React.useEffect(() => {
    if (customer.defaultLanguage) {
      changeAppLanguage(customer.defaultLanguage);
    }
    dispatch(getHeaderLeftComponent(LeftComponent));
  }, [customer]);

  if (Object.keys(customer).length === 0) return <></>;
  return (
    <div>
      <CustomerDetails
        open={openDetails}
        handleOpen={handleOpenDetails}
        handleClose={handleCloseDetails}
        customer={customer}
      />
      <CustomerSettingsModal
        open={openSettings}
        handleClose={handleCloseSettings}
        customerId={customerId}
        initialSection={settingsSection}
      />
    </div>
  );
};

export default CustomerHeader;
